import { render } from "./FlipHorizontal.vue?vue&type=template&id=5cf03c5c"
import script from "./FlipHorizontal.vue?vue&type=script&lang=js"
export * from "./FlipHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__